module.exports = __webpack_public_path__ + "static/media/Tier_5.6717d4d5.png";